export default "__VITE_ASSET__pFp3Vu7h__$_?nuxt_component=async&nuxt_component_name=IconFooterSecuritySv&nuxt_component_export=default__"